import React, { useCallback, useEffect, useState } from 'react';
import CrossAppIframeModal from './CrossAppIframeModal';
import {
  RCM_OPEN_CROSS_APP_EVENT,
  RCM_OPEN_IFRAME_MESSAGE,
  RCM_CLOSE_IFRAME_MESSAGE,
} from './rcmCrossAppNav';

/**
 * Listens for in-app custom events and parent/child postMessages to open
 * claim / ERA detail in an iframe overlay (never a new browser window).
 */
export default function CrossAppNavHost() {
  const [active, setActive] = useState(null);

  const openDetail = useCallback((detail) => {
    if (!detail?.url) return;
    setActive({
      url: detail.url,
      title: detail.title || (detail.kind === 'eob' || detail.kind === 'eob-list' ? 'ERA / remittance' : 'Claim detail'),
      organizationId: detail.organizationId || detail.organization_id,
    });
  }, []);

  const closeDetail = useCallback(() => setActive(null), []);

  useEffect(() => {
    window.__RCM_CROSS_APP_HOST__ = true;
    return () => {
      try {
        delete window.__RCM_CROSS_APP_HOST__;
      } catch {
        window.__RCM_CROSS_APP_HOST__ = false;
      }
    };
  }, []);

  useEffect(() => {
    const onLocal = (event) => {
      openDetail(event.detail);
    };

    const onMessage = (event) => {
      const data = event.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === RCM_CLOSE_IFRAME_MESSAGE) {
        closeDetail();
        return;
      }
      if (data.type !== RCM_OPEN_IFRAME_MESSAGE) return;
      // Accept from child iframes / sibling micro-apps (multi-port local + subdomains).
      openDetail(data);
    };

    const onLocalClose = () => closeDetail();

    window.addEventListener(RCM_OPEN_CROSS_APP_EVENT, onLocal);
    window.addEventListener(RCM_CLOSE_IFRAME_MESSAGE, onLocalClose);
    window.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener(RCM_OPEN_CROSS_APP_EVENT, onLocal);
      window.removeEventListener(RCM_CLOSE_IFRAME_MESSAGE, onLocalClose);
      window.removeEventListener('message', onMessage);
    };
  }, [openDetail, closeDetail]);

  return (
    <CrossAppIframeModal
      open={Boolean(active?.url)}
      url={active?.url}
      title={active?.title}
      organizationId={active?.organizationId}
      onClose={closeDetail}
    />
  );
}
